import React from 'react';
import PropTypes from 'prop-types';
// Core components
import TableRow from 'components/core/table/TableRow';
import TableCell from 'components/core/table/TableCell';
// Models
import mWorkspaceGroup from 'models/cpm/workspaceGroup';
// Custom
import { listRowSpecsShape, cpmWorkspaceGroupShape } from 'constants/PropTypesShapes';
import {
  AddCarparkIconButton,
  EditIconButton,
  DeleteIconButton,
  SlugIconButton,
  RemoveCarparkIconButton,
} from 'components/buttons/IconButtons';

const WorkspaceGroupRow = React.forwardRef(
  ({
    workspaceGroup, onAddCarparks, onEdit, onRemove, onRemoveCarpark, onManageSlug, rowSpecs,
  }, ref) => {
    const handleEdit = () => {
      onEdit(workspaceGroup);
    };

    const handleAddCarparks = () => {
      onAddCarparks(workspaceGroup);
    };

    const handleRemove = () => {
      onRemove(workspaceGroup);
    };

    const handleRemoveCarpark = () => {
      onRemoveCarpark(workspaceGroup);
    };

    const handleManageSlug = () => {
      onManageSlug(workspaceGroup);
    };

    return (
      <TableRow
        ref={ref}
        element={workspaceGroup}
        rowSpecs={rowSpecs}
        actions={[
          // ----- EDIT BUTTON ----- //
          onEdit && mWorkspaceGroup.isRegular(workspaceGroup) && <EditIconButton key="bEdit" onClick={handleEdit} />,
          // ----- MANAGE SLUG BUTTON ----- //
          <SlugIconButton key="bSlug" onClick={handleManageSlug} />,
          // ----- ADD CARPARK BUTTON ----- //
          onAddCarparks && mWorkspaceGroup.isRegular(workspaceGroup) && (
            <AddCarparkIconButton key="bAddCarparks" onClick={handleAddCarparks} />
          ),
          // ----- REMOVE BUTTON ----- //
          onRemove && <DeleteIconButton key="bDelete" onClick={handleRemove} />,
          // ----- REMOVE CARPARK BUTTON ----- //
          onRemoveCarpark && mWorkspaceGroup.isRegular(workspaceGroup) && (
            <RemoveCarparkIconButton key="bRemoveCarparks" onClick={handleRemoveCarpark} />
          ),
        ]}
      >
        <TableCell>{workspaceGroup.name}</TableCell>
      </TableRow>
    );
  },
);

WorkspaceGroupRow.displayName = 'WorkspaceGroupRow';

WorkspaceGroupRow.propTypes = {
  workspaceGroup: cpmWorkspaceGroupShape.isRequired,
  rowSpecs: listRowSpecsShape.isRequired,
  onAddCarparks: PropTypes.func,
  onRemove: PropTypes.func,
  onRemoveCarpark: PropTypes.func,
  onEdit: PropTypes.func,
  onManageSlug: PropTypes.func,
};

WorkspaceGroupRow.defaultProps = {
  onAddCarparks: null,
  onEdit: null,
  onRemove: null,
  onRemoveCarpark: null,
  onManageSlug: null,
};

module.exports = WorkspaceGroupRow;



// WEBPACK FOOTER //
// ./routes/cpm/routes/workspaces/assets/workspaceGroup/WorkspaceGroupRow.js